<template>
  <div id="classroomComments">
   <a-form  :model="formState"  :label-col="{ span: 8 }"  :wrapper-col="{ span: 16 }"  name="basic">
            <a-row justify="space-between">
                <a-col :span="4">
                    <a-form-item label="讲次名称">
                        <a-input v-model="formState.username" placeholder="请输入讲次名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="4">
                    <a-form-item label="班级名称">
                        <a-input v-model="formState.username" placeholder="请输入班级名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="上课时间">
                     <a-space direction="vertical" :size="12">
                        <a-range-picker v-model="formState.time1" />
                     </a-space>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="点名时间">
                     <a-space direction="vertical" :size="12">
                        <a-range-picker v-model="formState.time2" />
                     </a-space>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                    <a-form-item label="">
                        <a-button type="primary" style="margin-left: 20px;">
                            查询
                        </a-button>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <div style="margin-bottom: 15px;">
         <a-table :dataSource="dataSource" :columns="columns" />
        </div>
        <a-row type="flex" justify="end">
            <a-pagination v-model="current" :show-total="totalNum => `总 ${totalNum} 条`" show-quick-jumper :total="totalNum" />
        </a-row>
  </div>
</template>
<script>
export default {
  name: "classroomComments",
  components: {},
  data() {
    return {
      formState:{},
      current:1,
      totalNum:20,
      dataSource:[],
      columns:[
         {
            title: '序号',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '班级名称',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '讲次名称',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '上课时间',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '实到/应到',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '点名时间',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '已评价',
            dataIndex: 'name',
            key: 'name',
         }, {
            title: '操作',
            dataIndex: 'name',
            key: 'name',
         },
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
//@import ''; 引入公共css类
#classroomComments {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 15px;
}
</style>